import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import CSS from "../assets/css.png";
import HTML from "../assets/html.png";
import JavaScript from "../assets/javascript.png";
import Tailwind from "../assets/tailwind.png";
import ReactIcon from "../assets/react.png";
import Figma from "../assets/Figma.png";
import Csharp from "../assets/csharp.png";
import NextJS from "../assets/next-js.png";
import TypeScript from "../assets/typescript.png";
import Typewriter from "typewriter-effect";

const Home = () => {
  return (
    <div name="home" className="darkgray relative w-full py-32">
      {/*container*/}
      <div className="mx-auto flex max-w-[1000px] flex-col justify-center px-8 md:mt-[9rem]">
        <h1 className="text-center text-4xl font-semibold text-yellow-400 sm:text-left sm:text-6xl">
          Michael Seah
        </h1>

        <h2 className="text-center text-4xl font-semibold text-slate-300 sm:text-left sm:text-6xl">
          <Typewriter
            options={{
              strings: ["Front-End Dev", "UI/UX Designer"],
              autoStart: true,
              pauseFor: 2000,
              delay: 100,
              loop: true,
            }}
          />
        </h2>

        <p className="my-4 max-w-[700px] text-center text-slate-400 sm:text-left">
          I'm a passionate Singapore-based web designer who specializes in
          designing front-end web and mobile applications using React/Next.js.
        </p>

        {/*socials*/}
        <div className="flex justify-center text-slate-300 sm:justify-start">
          <ul className="flex flex-row">
            <li className="flex items-center justify-between px-4 py-4 duration-300 hover:text-yellow-400 sm:pl-0">
              <a
                className="w-full items-center"
                href="https://www.linkedin.com/in/seahjinhan/"
              >
                <FaLinkedin size={30} />
              </a>
            </li>
            <li className="duration300 flex items-center justify-between px-4 py-4 hover:text-yellow-400">
              <a
                className="w-full items-center"
                href="https://github.com/sjhmichael"
              >
                <FaGithub size={30} />
              </a>
            </li>
          </ul>
        </div>

        {/*icon container*/}
        <div className="flex flex-col items-center divide-x-0 divide-y-2 divide-neutral-700 py-12 text-slate-200 sm:flex-row sm:divide-x-2 sm:divide-y-0">
          <p className="py-3 sm:pr-6">Tech Stack</p>

          <div className="grid grid-cols-4 gap-6 py-3 sm:px-6 sm:py-0 md:grid-cols-8">
            <div className="w-16 rounded-lg py-4 shadow-md shadow-slate-950 duration-300 hover:scale-110 hover:bg-yellow-400 hover:text-neutral-900">
              <img className="mx-auto w-7" src={HTML} alt="HTML icon" />
            </div>

            <div className="w-16 rounded-lg py-4 shadow-md shadow-slate-950 duration-300 hover:scale-110 hover:bg-yellow-400 hover:text-neutral-900">
              <img className="mx-auto w-7" src={CSS} alt="CSS icon" />
            </div>

            <div className="w-16 rounded-lg py-4 shadow-md shadow-slate-950 duration-300 hover:scale-110 hover:bg-yellow-400 hover:text-neutral-900">
              <img
                className="mx-auto w-7"
                src={JavaScript}
                alt="Javascript icon"
              />
            </div>

            <div className="w-16 rounded-lg py-4 shadow-md shadow-slate-950 duration-300 hover:scale-110 hover:bg-yellow-400 hover:text-neutral-900">
              <img
                className="mx-auto w-7"
                src={TypeScript}
                alt="Tailwind icon"
              />
            </div>

            <div className="w-16 rounded-lg py-4 shadow-md shadow-slate-950 duration-300 hover:scale-110 hover:bg-yellow-400 hover:text-neutral-900">
              <img className="mx-auto w-7" src={Csharp} alt="Csharp icon" />
            </div>

            <div className="w-16 rounded-lg py-4 shadow-md shadow-slate-950 duration-300 hover:scale-110 hover:bg-yellow-400 hover:text-neutral-900">
              <img className="mx-auto w-7" src={NextJS} alt="Next-JS" />
            </div>

            <div className="w-16 rounded-lg py-4 shadow-md shadow-slate-950 duration-300 hover:scale-110 hover:bg-yellow-400 hover:text-neutral-900">
              <img className="mx-auto w-7" src={ReactIcon} alt="React icon" />
            </div>

            <div className="w-16 rounded-lg py-4 shadow-md shadow-slate-950 duration-300 hover:scale-110 hover:bg-yellow-400 hover:text-neutral-900">
              <img className="mx-auto w-7" src={Tailwind} alt="Tailwind icon" />
            </div>
          </div>
        </div>

        {/*button container*/}
        {/* <Link className="w-full sm:w-fit" to="work" smooth={true} duration={500}>
          <div className="flex sm:justify-start justify-center">
            <div class="btn" to="work">
              <div class="btn-texture"></div>
              <div class="btn-text">View Work</div>
            </div>
          </div>
        </Link> */}

        <div className="flex h-fit justify-center align-middle duration-300 sm:justify-start">
          <Link to="work" smooth={true} duration={500}>
            <div class="btn" to="work">
              <div class="btn-texture"></div>
              <div class="btn-text">View Work</div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Home;
